import { FC, PropsWithChildren } from "react";
import { Box } from "@chakra-ui/react";

const MasonryGrid: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      css={{
        columnCount: { base: 1, md: 2 },
        columnGap: "1rem",
        "& > *": {
          breakInside: "avoid",
          marginBottom: "1rem",
          width: "100%",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default MasonryGrid;
